import {
    call,
    take,
    select
} from 'redux-saga/effects';
import {
    NEW_CATEGORY
} from '../actions/newCategoryActions';
import {
    beginRequest
} from './categoryInitialSagas';
import {
    L10N_CATEGORY_SEO_TITLE,
    L10N_CATEGORY_SEO_META_DESCRIPTION
} from '../../../core/js/enums/localizationEnums';
import {
    interpolate
} from '../../../core/js/utils/localizationUtils';

/**
 * Update the title and meta description when navigating to a category via
 * the NEW_CATEGORY action.
 *
 * This function is only intended to be used by newCategorySaga after the state
 * is hydrated with the new category data.
 *
 * @param {object} state Redux state
 * @returns {undefined}
 */
function performNewCategorySideEffect(state) {
    if (state.category &&
        state.category.breadcrumbs &&
        state.category.breadcrumbs.length &&
        state.category.breadcrumbs[state.category.breadcrumbs.length - 1]) {
        const crumb = state.category.breadcrumbs[state.category.breadcrumbs.length - 1];
        const chromeLocalization = state.core.localizations.containers.chromeLocalization;
        const l10nTitle = chromeLocalization[L10N_CATEGORY_SEO_TITLE];
        const l10nDescription = chromeLocalization[L10N_CATEGORY_SEO_META_DESCRIPTION];

        $('title').html(interpolate(l10nTitle, [
            crumb.seo && crumb.seo.title ?
                crumb.seo.title :
                crumb.displayName,
            state.core.constants.siteName]));

        $('meta[name="description"]').attr('content',
            crumb.seo && crumb.seo.metaDescription ?
                crumb.seo.metaDescription :
                interpolate(l10nDescription, [crumb.displayName]));
    }
}

export function *newCategorySaga() {
    let payload = {};

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(NEW_CATEGORY)) {
        let state = yield select();
        const requestedPage = 1;

        yield call(
            beginRequest,
            requestedPage,
            payload.requestType,
            payload.categoryId,
            payload.searchTerm,
            payload.queryString
        );
        yield call(performNewCategorySideEffect, state);
    }
}

export default [
    newCategorySaga
];
